module.exports = __webpack_public_path__ + "static/img/Mask Group 220.58fcbb6e.png";